@if (cropperData()) {
  <outlaw-dialog-wrapper [dialogTitle]="'Crop cover image'">
    <div class="cropper-container">
      <image-cropper
        [imageBase64]="cropperData()!.imageData"
        [maintainAspectRatio]="true"
        [aspectRatio]="290 / 160"
        [roundCropper]="false"
        (imageCropped)="onImageCropped($event)"
        class="cover-cropper"
      />
    </div>
    <div class="cropper-actions">
      <button class="community-button ghost" (click)="cancelCropper()">Cancel</button>
      <button class="community-button primary with-line" (click)="applyCrop()">Save</button>
    </div>
  </outlaw-dialog-wrapper>
} @else {
  <outlaw-dialog-wrapper [dialogTitle]="title">
    <div class="dialog-form">
      <div class="name-field" [class.has-value]="name()">
        <label class="field-label">Selection name</label>
        <input
          type="text"
          class="field-input"
          maxlength="100"
          [ngModel]="name()"
          (ngModelChange)="name.set($event)"
        />
      </div>
      <div class="thumbnail-upload" [class.has-image]="coverPreview()" (click)="fileInput.click()">
        @if (isUploading()) {
          <app-community-loader class="thumbnail-loader" />
        } @else if (coverPreview()) {
          <img [src]="coverPreview()" alt="Cover" class="thumbnail-preview" />
          <!-- TODO: enable when API supports cover removal
          <button class="thumbnail-remove" (click)="removeCover($event)">
            <outlaw-icon name="close" size="10px" />
          </button>
          -->
        } @else {
          <i class="thumbnail-icon"></i>
          <span class="thumbnail-label">Thumbnail</span>
        }
        <input #fileInput type="file" accept="image/*" hidden (change)="onFileSelected($event)" />
      </div>
    </div>

    <button
      class="save-btn"
      [class.save-btn--active]="isValid"
      [disabled]="!isValid"
      (click)="onSave()"
    >
      {{ isUploading() ? 'Uploading...' : 'Save' }}
    </button>
  </outlaw-dialog-wrapper>
}
